// extracted by mini-css-extract-plugin
module.exports = {"container":"NoResult_container__7kKWY","north-no-result":"NoResult_north-no-result__LIMVx","no-result":"NoResult_no-result__2tIt0"};